export class AbilityCreateModel {
  public Pn?: number;
  public Description?: string;
  public Spt?: number;
  public LimitStatus?: number;
  public LimitNote?: string;
  public OperationPlace?: string;
  public OperationPlaceCode?: string;
  public Remarks?: string;
}
export default AbilityCreateModel;
